import { render, staticRenderFns } from "./AdminChangeList.vue?vue&type=template&id=19c89684&scoped=true"
import script from "./AdminChangeList.vue?vue&type=script&lang=js"
export * from "./AdminChangeList.vue?vue&type=script&lang=js"
import style0 from "./AdminChangeList.vue?vue&type=style&index=0&id=19c89684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c89684",
  null
  
)

export default component.exports